<template>
  <div class="container">
    <h1>代理测试</h1>
    <button @click="testProxy">测试代理</button>
    <div class="result" v-if="result">
      <h3>测试结果</h3>
      <pre>{{ result }}</pre>
    </div>
    <div class="error" v-if="error">
      <h3>错误信息</h3>
      <pre>{{ error }}</pre>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'TestProxy',
  data() {
    return {
      result: null,
      error: null
    };
  },
  methods: {
    async testProxy() {
      try {
        console.log('发送请求到: /yisheng/detect-client');
        const response = await api.get('/yisheng/detect-client');
        this.result = JSON.stringify(response.data, null, 2);
        this.error = null;
      } catch (error) {
        console.error('请求失败:', error);
        this.error = error.message || '未知错误';
        if (error.response) {
          this.error += '\n状态码: ' + error.response.status;
          this.error += '\n响应数据: ' + JSON.stringify(error.response.data, null, 2);
        }
        this.result = null;
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
button {
  background-color: #007bff;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin: 10px 0;
}
button:hover {
  background-color: #0056b3;
}
.result, .error {
  margin-top: 20px;
  padding: 15px;
  border-radius: 5px;
}
.result {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
pre {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  padding: 15px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>